// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.auth-header {
  height: 12vh;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #FFFFFF;
  background-color: #434C63;
}

@media screen  and (max-width: 480px) {
  .auth-header{

    text-align: center;
  }
  .auth-header_title{
    width: 70%;
    font-size: 20px;
    display: flex;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Header/AuthHeader/style.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE;;IAEE,kBAAkB;EACpB;EACA;IACE,UAAU;IACV,eAAe;IACf,aAAa;EACf;AACF","sourcesContent":[".auth-header {\n  height: 12vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: #FFFFFF;\n  background-color: #434C63;\n}\n\n@media screen  and (max-width: 480px) {\n  .auth-header{\n\n    text-align: center;\n  }\n  .auth-header_title{\n    width: 70%;\n    font-size: 20px;\n    display: flex;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
